<div>
    <div class="row" >
        <div class="col-xl-12" >
            <div class="card-box">
                <div class="row pb-3">
                    <div class="col-xl-12">
                        <from-date-to-date-pickers  :title="''"
                                                    :fromDate="selectedStartDate"
                                                    :toDate="selectedEndDate"
                                                    :elementId="'dashboardDateFilter'"
                                                    :dateFormat="'dd/MM/yyyy'"
                                                    :hideClearButton="hideClearButton"
                                                    :initialiseDate="initialiseDatePicker"
                                                    :initialiseDatePickerEndDate="initialiseDatePickerEndDate"
                                                    @clearDatePicker="onDateFilterClearClick"
                                                    @fromDateSelected="onFromDateCreatedSelect"
                                                    @toDateSelected="onToDateCreatedSelect"></from-date-to-date-pickers>
                    </div>
                </div>
                <div class="row">
                    <div class="col-auto d-flex flex-column mb-2">
                        <button class="btn btn-primary" @click="downloadNewSignUpReport">
                            New Sign Up Report
                        </button>
                    </div>
                    <div class="col-auto d-flex flex-column mb-2">
                        <button class="btn btn-primary" @click="downloadDetailTransactionReport">
                            Detailed Transaction Report
                        </button>
                    </div>
                    <div class="col-auto d-flex flex-column mb-2">
                        <button class="btn btn-primary" @click="downloadCustomerPointsBalanceReport">
                            Customer Points Balances Report
                        </button>
                    </div>
                    <div class="col-auto d-flex flex-column mb-2" @click="downloadCustomerEarningAndRedeemingFrequencyReport">
                        <button class="btn btn-primary">
                            Customer Earning VS Redemption Frequency Report
                        </button>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="card-box">
                        <h4>Monthly Reports</h4>
                        <label>Year</label>
                        <bootstrap-select :selectOptions="years" :selectedOption="selectedYear" :elementId="'orderTypeFilterSelect'"
                                          :returnSelectedOptionText="true"
                                          @changeSelect="onYearSelect"></bootstrap-select>
                    </div>
                </div>
                
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="card-box">
                        <div v-show="customerSignUpsPerMonthData !== null">
                            <h4 class="header-title mb-3">Customer Sign Ups Per Month</h4>
                            <div data-ui-jp="echarts" id="customerSignUpsPerMonthChart" style="height:500px"></div>
                        </div>
                        <div v-show="customerSignUpsPerMonthData === null">
                            <h4 class="header-title mb-3 text-center">
                                No Data Available
                            </h4>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="card-box">
                        <div v-show="totalVolumePurchasedPerProductMonthlyData !== null">
                            <h4 class="header-title mb-3">Total Volume Of Product Purchased (Monthly)</h4>
                            <div data-ui-jp="echarts" id="totalVolumePurchasedPerProductMonthlyData" style="height:500px"></div>
                        </div>
                        <div v-show="totalVolumePurchasedPerProductMonthlyData === null">
                            <h4 class="header-title mb-3 text-center">
                                No Data Available
                            </h4>
                        </div>

                    </div>
                </div>
            </div>
<!--            <div class="row">-->
<!--                <div class="col-md-12">-->
<!--                    <div class="card-box">-->
<!--                        <div v-show="customerVolumePerDayData !== null">-->
<!--                            <h4 class="header-title mb-3">Customer Volume Per Day</h4>-->
<!--                            <div data-ui-jp="echarts" id="customerVolumePerDayChart" style="height:500px"></div>-->
<!--                        </div>-->
<!--                        <div v-show="customerVolumePerDayData === null">-->
<!--                            <h4 class="header-title mb-3 text-center">-->
<!--                                No Data Available-->
<!--                            </h4>-->
<!--                        </div>-->

<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="row">-->
<!--                <div class="col-md-6">-->
<!--                    <div class="card-box">-->
<!--                        <div v-show="totalVolumePerStatusChartData !== null && totalVolumePerStatusChartData.length > 0">-->
<!--                            <h4 class="header-title mb-3">Total Volume Per Order Status (Litres)</h4>-->
<!--                            <div data-ui-jp="echarts" id="totalVolumePerOrderStatus" style="height:500px"></div>-->
<!--                        </div>-->
<!--                        <div v-show="totalVolumePerStatusChartData === null || totalVolumePerStatusChartData.length === 0">-->
<!--                            <h4 class="header-title mb-3 text-center">-->
<!--                                No Data Available-->
<!--                            </h4>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="col-md-6">-->
<!--                    <div class="card-box">-->
<!--                        <div v-show="totalAmountPerStatusChartData !== null && totalAmountPerStatusChartData.length > 0">-->
<!--                            <h4 class="header-title mb-3">Total Sales Per Order Status (Rands)</h4>-->
<!--                            <div data-ui-jp="echarts" id="totalAmountPerOrderStatus" style="height:500px"></div>-->
<!--                        </div>-->
<!--                        <div v-show="totalAmountPerStatusChartData === null || totalAmountPerStatusChartData.length === 0">-->
<!--                            <h4 class="header-title mb-3 text-center">-->
<!--                                No Data Available-->
<!--                            </h4>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
        </div>
    </div>
    <loading-spinner :showSpinner="loading"></loading-spinner>
    
    <error-modal
        :modalHeading="'Error'"
        :elementId="'dashboardErrorModal'"
        :modalMessage="errorModal.errorMessage"
        :showModal="errorModal.showModal"
        @okClicked="onErrorModalOkClicked"></error-modal>
</div>
